import { useEffect, useMemo, useState } from "react";

import { PanesContainer, useNotionDatabase } from "dev";

import { OrderDetails } from "../[uuid]/details";
import { MockDeliveryStatusProvider } from "@/src/contexts/delivery-status-context";
import { fetchDeliveryStatus } from "@/src/services/dev";
import { DeliveryStatus, Status, Substatus } from "@/src/types";

export default function Cart() {
  const db = useNotionDatabase("8c4fe0fab8f34935930d914dbff0ae7a");

  const [deliveryStatuses, setDeliveryStatuses] = useState<DeliveryStatus[]>(
    []
  );
  const [status, setStatus] = useState<Status | null>(null);
  const [substatus, setSubstatus] = useState<Substatus<Status> | null>(null);

  const data = useMemo(() => {
    return db
      ?.map((r) => ({
        uuid: r["Order UUID"],
        tstamp: r["Order Timestamp"],
        status: r["Status"] as Status,
        substatus: r["Sub-status"] as Substatus<Status>,
      }))
      .filter((r) => r.uuid && r.tstamp);
  }, [db]);

  useEffect(() => {
    const promises = data?.map(fetchDeliveryStatus);
    if (!promises) return;
    Promise.all(promises).then(setDeliveryStatuses);
    setStatus(data?.[0]?.status || null);
    setSubstatus(data?.[0]?.substatus || null);
  }, [data]);

  return (
    <PanesContainer
      items={deliveryStatuses.filter((d) => d.order !== null)}
      renderItem={(deliveryStatus) => (
        <>
          <>
            <span>status: {status}</span>
            <span>substatus: {substatus}</span>
          </>

          <MockDeliveryStatusProvider deliveryStatus={deliveryStatus}>
            <OrderDetails />
          </MockDeliveryStatusProvider>
        </>
      )}
    />
  );
}
